import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Auth } from 'aws-amplify';
import Routes from '../Routes';
import config from '../config';

import './App.css';

import BackToTop from '../components/BackToTop';
import Flash from '../components/Flash';

import arrowLeft from '../assets/icons/arrow-white-left.svg';
import arrowRight from '../assets/icons/arrow-white-right.svg';
import dashboard from '../assets/icons/ico-dashboard.svg';
import uniqueuser from '../assets/icons/ico-uniqueuser.svg';
import mobileverify from '../assets/icons/ico-mobileverify.svg';
import icverify from '../assets/icons/ico-icverify.svg';
import checks from '../assets/icons/ico-checks.svg';
import bank from '../assets/icons/ico-bank.svg';
import logout from '../assets/icons/ico-logout.svg';

class App extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      show: true,
    };
  }

  async componentDidMount() {
    try {
      if (await Auth.currentSession()) {
        this.userHasAutheticated(true);
      }
    }
    catch(e) {
      if (e !== 'No current user') {
        console.log('Auth: ', e.message);
      }
    }
    this.setState({ isAuthenticating: false });
  }

  userHasAutheticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  handleLogout = async (event) => {
    await Auth.signOut();
    this.userHasAutheticated(false);
    this.props.history.push("/");
  }

  handleExpand = (e) => {
    e.preventDefault();
    this.setState({show: !this.state.show});
  }

  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAutheticated: this.userHasAutheticated,
    };

    const { show, isAuthenticated, isAuthenticating } = this.state;
    
    return (
      !isAuthenticating &&
      <ConnectedRouter history={this.props.history}>
        <div className="App">
          <div className={`appWrapper ${show && isAuthenticated ? "show" : null}`}>
            <button className="sideNavBtn" onClick={this.handleExpand}>Expnd</button>
            { isAuthenticated ?
              <div className={`sideBar fade-in ${show ? "show" : null}`}>
                <Link className="tooltipWrap" to="/home"><img src={dashboard} alt="dashboard"/><p>Dashboard</p><span className="tooltiptext">Dashboard</span></Link>
                <Link className="tooltipWrap" to="/unique-users"><img src={uniqueuser} alt="users"/><p>View All Users</p><span className="tooltiptext">View All Users</span></Link>
                <Link className="tooltipWrap" to="/suspicious-users"><img src={uniqueuser} alt="suspicious users"/><p>View All Suspicious Users</p><span className="tooltiptext">View All Suspicious Users</span></Link>
                <Link className="tooltipWrap" to="/mobile-verifications"><img src={mobileverify} alt="mobileverify"/><p>View SMS Issue</p><span className="tooltiptext">View SMS Issue</span></Link>
                <Link className="tooltipWrap" to="/ic-verifications"><img src={icverify} alt="icverify"/><p>View IC Issues</p><span className="tooltiptext">View IC Issues</span></Link>
                <Link className="tooltipWrap" to="/check-verifications"><img src={checks} alt="checkverify"/><p>View Check Issue</p><span className="tooltiptext">View Check Issue</span></Link>
                <Link className="tooltipWrap" to="/checks"><img src={checks} alt="View all checks"/><p>View All Checks</p><span className="tooltiptext">View All Checks</span></Link>
                <Link className="tooltipWrap" to="/leads"><img src={bank} alt="View all checks"/><p>View All Leads</p><span className="tooltiptext">View All Leads</span></Link>
                <button className="tooltipWrap" onClick={this.handleLogout}><img src={logout} alt="logout"/><p>Logout</p><span className="tooltiptext">Logout</span></button>
                <p>v{config.app.version}</p>
                <button className="collapseBtn" onClick={this.handleExpand}>
                  <img src={`${show ? arrowLeft : arrowRight}`} alt={`${show ? 'Collapse' : 'Expand'}`} />
                </button>
              </div>
              : null
            }
            <Routes childProps={childProps} />
            { isAuthenticated ? <BackToTop scrollStepInPx="50" delayInMs="5" /> : null }
            <Flash />
          </div>
        </div>
      </ConnectedRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.jsx